import BrowserWidthBucket from 'owa-layout/lib/store/schema/BrowserWidthBucket';
import { mergeStyles } from '@fluentui/merge-styles';

export function getListContainerStyles(
    listWidth: number,
    browserWidthBucket: BrowserWidthBucket
): string {
    return mergeStyles({
        width: listWidth,
        maxWidth: getListViewMaxWidth(browserWidthBucket),
    });
}

export function getListViewMaxWidth(browserWidthBucket: BrowserWidthBucket): number {
    if (browserWidthBucket <= BrowserWidthBucket.From919_To999) {
        return 260;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1080_To1199) {
        return 310;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1366_To1399) {
        return 380;
    }
    if (browserWidthBucket < BrowserWidthBucket.From1400_To1599) {
        return 450;
    }
    return 520;
}
